export default __webpack_public_path__ + "1.18.12/static/media/LibreDataSharecode_SimplifiedChinese.f3c534ca.svg";